<template>
    <el-form :model="form" ref="form" label-width="100px" :inline-message=true>
        <el-form-item label="分班ID："  style="margin-left:10px" class="limit-configure" >
            <el-col :span="4" >
              {{$route.query['id']}}
            </el-col>
        </el-form-item>
        <el-form-item label="备注：" label-width="100px" class="limit-configure">
            <el-input style="width: 300px;" type="textarea" v-model="form.memo"
                      @input="emit"></el-input>
        </el-form-item>
    </el-form>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>

<script>
import CommonService from "~/services/common";
export default {
    data() {
        return {
            form: {
                memo:''
            },
        };
    },
    created() {
        CommonService.getQueryCode({
            customer_id: this.$route.query['id'],
            product_id :  103
        }).then(res => {
            if(res.data['memo'] != '') {
                this.form.memo =res.data['memo']
            }
        })

    },
    props:{
        hidden:{
            required:false
        }
    },
    methods:{
        emit() {
            this.$emit('getMemo', this.form);
        },
    },

}
</script>




// WEBPACK FOOTER //
// src/views/order/division/limitConfigure.vue